import createDataContext from "./createDataContext";
import dataService from "../data/dataService";
import authService from "../data/api/authService";

const { auth } = dataService;

const authReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "set_password_reset_success":
      return {
        ...state,
        successMessage: "Contraseña reestablecida con éxtio.",
        errorMessage: "",
      };
    case "set_recovery_email":
      return {
        ...state,
        recoveryEmail: payload,
        successMessage: "Correo de recuperación enviado exitosamente",
        errorMessage: "",
      };
    case "reset_values":
      return {
        ...state,
        errorMessage: "",
        successMessage: "",
      };
    case "add_error":
      return { ...state, errorMessage: payload, successMessage: "" };
    case "signin":
      return {
        ...state,
        token: payload,
        successMessage: "Inicio de sesión exitoso",
        errorMessage: "",
      };
    case "set_auth_status":
      return {
        ...state,
        token: payload.token,
        isAuthenticated: payload.isAuthenticated,
        errorMessage: "",
      };
    case "set_user":
      return { ...state, user: payload };
    case "signout":
      return {
        token: null,
        user: null,
        successMessage: "Sesión finalizada",
        errorMessage: "",
      };
    case "update_me":
      return {
        ...state,
        successMessage: "Usuario actualizado con éxito",
        errorMessage: "",
      };
    default:
      return state;
  }
};

const signin = (dispatch) => async ({ email, password }) => {
  try {
    // registers login
    const loginRes = await auth.login(email, password);
    authService.registrarLogin(loginRes.data.token, true);
    dispatch({
      type: "signin",
      payload: loginRes.data.token,
    });
    dispatch({
      type: "set_auth_status",
      payload: {
        token: authService.getToken(),
        isAuthenticated: authService.getIsAuthenticated(),
      },
    });

    // registers user
    const meRes = await auth.me();
    authService.registrarUsuario(meRes.data);
    dispatch({ type: "set_user", payload: meRes.data });
  } catch (err) {
    dispatch({ type: "add_error", payload: err });
    console.error(err);
  }
};

const signout = (dispatch) => (callback = () => {}) => {
  dispatch({ type: "reset_values" });
  authService.setLogOut();
  callback();
  dispatch({
    type: "set_auth_status",
    payload: {
      token: authService.getToken(),
      isAuthenticated: authService.getIsAuthenticated(),
    },
  });
};

const getMe = (dispatch) => async () => {
  dispatch({ type: "reset_values" });
  try {
    const res = await auth.me();
    const { data } = res;
    dispatch({ type: "set_user", payload: data });
  } catch (err) {
    dispatch({ type: "add_error", payload: err });
    console.error(err);
  }
};

const updateMe = (dispatch) => async (updatedInfo, callback = () => {}) => {
  dispatch({ type: "reset_values" });
  try {
    const res = await auth.updateMe(updatedInfo);
    const { data } = res;
    dispatch({ type: "update_me" });
    dispatch({ type: "set_user", payload: data });
    callback();
  } catch (err) {
    dispatch({ type: "add_error", payload: err });
    throw new Error(err);
  }
};

const sendRecoveryToken = (dispatch) => async ({ email }) => {
  dispatch({ type: "reset_values" });
  try {
    await auth.passwordReset(email);
    dispatch({ type: "set_recovery_email", payload: email });
  } catch (err) {
    console.log(err.response.statusText);
    dispatch({ type: "add_error", payload: err.response.statusText });
    throw new Error(err);
  }
};

const recoverPassword = (dispatch) => async ({
  newPassword,
  newPassword2,
  uid,
  token,
}) => {
  dispatch({ type: "reset_values" });
  try {
    await auth.passwordResetConfirmation(newPassword, newPassword2, uid, token);
    dispatch({ type: "set_password_reset_success" });
  } catch (err) {
    const msg = Object.entries(err.response.data).join(", ");
    dispatch({ type: "add_error", payload: msg });
    throw new Error(err);
  }
};

const resetValues = (dispatch) => () => dispatch({ type: "reset_values" });

export const { Provider, Context } = createDataContext(
  authReducer,
  {
    signin,
    signout,
    getMe,
    updateMe,
    sendRecoveryToken,
    recoverPassword,
    resetValues,
  },
  {
    token: authService.getToken(),
    isAuthenticated: authService.getIsAuthenticated(),
    user: authService.getUser(),
    recoveryEmail: null,
    successMessage: "",
    errorMessage: "",
  }
);
